// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Name
    name: 'g-login-recovery',
    // #endregion
    // #region Data
    data: () => ({
        eMailAddress: "",
        errorMessage: "",
        isWorking: false
    }),
    // #endregion
    // #region Create
    created() {
        this.eMailAddress = appHost.login.getUsername() ?? '';
    },
    // #endregion
    // #region Watch
    watch: {
        eMailAddress: function (val) {
            this.errorMessage = '';
        },
    },
    // #endregion
    // #region Computed
    computed: {
        hasError() {
            return !utils.isEmpty(this.errorMessage);
        },
        form() {
            return this.$refs?.frmMain?.$form;
        },
        disableSubmit() {
            return utils.isEmpty(this.eMailAddress);
        }
    },
    // #endregion
    // #region Methods
    methods: {
        async OnExecute() {
            // #region Validation
            if (!this.form.validate()) {
                return;
            }
            // #endregion
            // #region Core
            try {
                // #region Start
                this.isWorking = true;
                // #endregion
                // #region Run
                await appHost.api.post('identity/profile/password-recovery', null, { params: { address: this.eMailAddress } });
                // #endregion
                // #region Next
                this.$router.push({ path: '/login/recovery', hash: '#submit' });
                // #endregion
            }
            // #endregion
            // #region Errors
            catch (e) {
                this.errorMessage = utils.getAxiosErrorMessage(e);
            }
            finally {
                this.isWorking = false;
            }
            // #endregion
        },
        OnBack() {
            this.$router.push({ path: '/login' });
        }
    }
    // #endregion
});
// #endregion
